import React, { useEffect, useContext, useState, useCallback } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { AppContext, DispatchContext } from "../AppContext";
import Service from "../services/service";
import * as actions from "../actions/actions";
import { showCaptcha, config, resolveNotificationMessage } from '../helpers/constants';
import { Box, Paper, Typography, TextField, Button, Link } from "@material-ui/core";
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import FullScreenPage from "./FullScreenPage";
import IconLabel from './IconLabel';
import DividerLabel from "./DividerLabel";
import { ReactComponent as CheckedIcon } from '../assets/icons/checked.svg';
import LoadingScreen from "./LoadingScreen";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ReactMarkdown from 'react-markdown';


const useStyles = makeStyles((theme) => ({
  paper: {
    width: 800,
    minHeight: 500,
    position: "relative",
    overflow: "auto"
  }
}));

const Accordion = withStyles({
  root: {
    boxShadow: 'none',
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      //margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    flexDirection: 'column'
  },
}))(MuiAccordionDetails);

export default function Contact(props) {
  const { cancelUrl } = props;
  const dispatch = useContext(DispatchContext);
  const state = useContext(AppContext);
  const s = state.strings;
  const classes = useStyles();
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [contactData, setContactData] = useState({});
  const [expanded, setExpanded] = useState(false);
  const [faqExpanded, setFaqExpanded] = useState(false);

  useEffect(() => {
    setContactData({
      ...contactData,
      name: state.user.name || '',
      mail: state.user.mail || '',
      userId: state.user.userId || ''
    });
  }, []);

  useEffect(() => {
    if (!state.user.loggedIn) {
      showCaptcha();
    }
  }, []);

  useEffect(() => {
    if (state.user.sessionId) {
      Service.loadFAQs().then(res => {
        if (res.success) {
          dispatch(actions.get_faqs(res || []))
        } else {
          dispatch(actions.openToast({ type: "error", message: res.errors[0], status: true }));
        }
      });
    }
  }, [state.lang, state.user.sessionId]);


  const handleExpanded = (panel) => (event, isExpanded) => {
    setFaqExpanded(33);
    setExpanded(isExpanded ? panel : false);
  };
  const handleFaqExpanded = (panel) => (event, isExpanded) => {
    setFaqExpanded(isExpanded ? panel : false);
  };

  const handleFormChange = (value, key) => {
    setContactData({ ...contactData, [key]: value })
  }

  const onSendMessageButtonClicked = (e) => {
    e.preventDefault();
    captchaAction("contact", sendContactMail);
  }

  const captchaAction = (action, fn) => {
    const captchas = document.getElementsByClassName("grecaptcha-badge");
    if (captchas.length > 0 && captchas[0].style.visibility != "hidden") {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(config.captchaKey, { action: action }).then(function (token) {
          Service.verifyReCaptcha(token).then((verifyRes) => {
            if (verifyRes.success) {
              fn();
            } else {
              dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(verifyRes.errors[0], s.notificationMessage) }));
            }
          });
        });
      });
    } else {
      fn();
    }
  }

  const sendContactMail = () => {
    Service.sendContactMail(contactData).then(res => {
      setLoading(false);
      if (res.success) {
        setSent(true);
      } else {
        dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage) }));
      }
    });
  }

  const onCancelButtonClicked = () => {
    if (state.user.loggedIn) {
      dispatch(actions.navigate_to("/dashboard"));
    } else {
      window.location.href = config.backendUrl + s.links.home;
    }
  }


  if (sent) {
    return (
      <FullScreenPage>
        <Paper elevation={5} className={classes.paper}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%", padding: 60 }}>
            <Box mt={2} />
            <CheckedIcon style={{ fill: '#009900' }} height={100} width={100} />
            <Box mt={4} />
            <Typography paragraph variant="h6">{s.contactForm.thankYouTitle}</Typography>
            <Typography align="center" color="secondary">{s.contactForm.thankYouText}</Typography>
            <Box mt={4} />
            <Button onClick={onCancelButtonClicked} variant="outlined" style={{ marginLeft: 8 }}>{s.common.close}</Button>
          </div>
        </Paper>
      </FullScreenPage>
    )
  }

  const formCompleted = contactData.name && contactData.mail && contactData.subject && contactData.message;

  return (
    <FullScreenPage>
      {/*<Dialog fullWidth={true} maxWidth="md" scroll="Paper" open={true}>*/}
      <Paper elevation={5} className={classes.paper}>
        <LoadingScreen status={loading} opacity={0.75} text={s.contactForm.sendingMessage} />
        <div style={{ padding: 32 }}>
          <Typography variant="h6">{s.contactForm.title}</Typography>
          <DividerLabel />

          {state.faqs.map((cat, i) => (
            <Accordion expanded={expanded === cat.Id} onChange={handleExpanded(cat.Id)}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography color="secondary">{cat.Title}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {cat.Faqs.map((faq, i) => (
                  <Accordion expanded={faqExpanded === faq.Id} onChange={handleFaqExpanded(faq.Id)}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                    >
                      <Typography>{faq.Question}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {faq.Answer == "[Form]" ?
                        <>
                          <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
                            <TextField style={{ width: "48%" }} size="small" required label={s.contactForm.name}
                              value={contactData.name}
                              onChange={(e) => handleFormChange(e.target.value, "name")}
                            />
                            <TextField style={{ width: "48%" }} size="small" required label={s.contactForm.mail}
                              value={contactData.mail}
                              onChange={(e) => handleFormChange(e.target.value, "mail")}
                            />
                          </div>
                          <TextField style={{ marginTop: 16, width: "100%" }} size="small" required label={s.contactForm.subject}
                            value={contactData.subject}
                            onChange={(e) => handleFormChange(e.target.value, "subject")}
                          />
                          <TextField style={{ marginTop: 16, width: "100%" }} multiline rows={5} rowsMax={10} size="small" label={s.contactForm.message}
                            value={contactData.message}
                            onChange={(e) => handleFormChange(e.target.value, "message")}
                          />
                          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 24 }}>
                            <Button onClick={(e) => onSendMessageButtonClicked(e)} disabled={!formCompleted} variant="contained" color="primary">{s.contactForm.sendMessageButton}</Button>
                          </div>

                        </>
                        :
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          <Typography>
                            <ReactMarkdown>{faq.Answer}
                            </ReactMarkdown>
                          </Typography>
                          {faq.Related &&
                            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 24 }}>
                              <Link target="_blank" href={config.backendUrl + faq.Related}>Weitere Informationen</Link>
                            </div>
                          }
                        </div>
                      }

                    </AccordionDetails>
                  </Accordion>
                ))}

              </AccordionDetails>
            </Accordion>
          ))}





          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 24 }}>
            <Button onClick={onCancelButtonClicked} variant="outlined" style={{ marginLeft: 8 }}>{s.common.cancel}</Button>
          </div>
        </div>
      </Paper>

    </FullScreenPage>
  );
}
